import * as React from 'react';
import { Table } from '../common';

interface AADAppsImportProps {
	application: any;

}

const AADAppsImportTableRow = ({application} : AADAppsImportProps) => {

    return ( 	
        <Table.Row>
            <Table.Cell>
                <div className='small-margin'>{application.appGuid}</div>
            </Table.Cell>
            <Table.Cell>
                <div className='small-margin'>{application.ownerUPN}</div>
            </Table.Cell>
            <Table.Cell>
                <div className='small-margin'>{application.environment}</div>
            </Table.Cell>
            <Table.Cell>
                <div className='small-margin'>{application.expirationDate}</div>
            </Table.Cell>
            <Table.Cell>
                <div className='small-margin'>{application.cartaIds}</div>
            </Table.Cell>
        </Table.Row>
    );
}

export default AADAppsImportTableRow;